import React from "react"

const Seven = ({ width = "68", height = "64", viewBox = "0 0 68 64" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-seven-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.858 17.429c3.55 1.443 9.055.27 10.84-.883L52 19.103c-7.068 7.614-8.815 13.244-10.248 18.88-.789 3.1-.853 8.436-.853 10.017H23.717c0-2.06.305-7.684 2.389-11.561 3.048-5.673 6.41-7.576 9.99-9.602.146-.084.294-.167.441-.25-1.946 1.104-4.215.605-6.513.099-1.655-.365-3.326-.733-4.904-.507-2.816.403-4.56 3.191-4.56 4.548H16V17.36h4.494v1.425c5.75-4.208 13.893-2.769 17.364-1.357Zm-6.51 18.039c.164-.214.3-.392.395-.525.509-.703.262-1.257-.743-.741-1.294.665-2.724 2.075-3.687 3.854-.943 1.785-1.533 4.146-1.235 5.344.23.93.906.685 1.19-.094.053-.145.12-.344.199-.584.304-.917.803-2.425 1.524-3.77.717-1.342 1.736-2.673 2.357-3.484Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-seven-icon"
          x="0"
          y="0"
          width="68"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Seven
